/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useState } from 'react'

import { Box } from '@mui/material'
import { getCountryDataByYearAndMetric, getYearSliderLimits } from 'utils/getDataAIMetricsOT'
import { useActions, useAppSelector } from 'hooks'
import { inputFilter, worldmapYear } from 'store/AIMetricOT/reducerSlice'
import { DOWNLOAD_FILE_NAME } from 'constant'
import DownloadImages from 'components/common/Download/DownloadImages'
import { DownloadType } from 'types'
import { useImageDownload } from 'components/common/Download/useImageDownload'
import ChartHeader from 'components/common/ChartHeader/ChartHeader'
import { getMetricByKey } from 'utils/getMetricListByType'
import { getAllMetricsFromGroups } from 'utils/getAllMetricsFromGroups'
import SimpleWorldMap from 'components/Worldmap/SimpleWorldMap'

export default function Worldmap() {
  const currentFilter = useAppSelector(inputFilter)
  const currentYear = useAppSelector(worldmapYear)
  const countryData = useAppSelector(({ vibrancy }) => vibrancy.countryData)
  const metricGroups = useAppSelector(({ vibrancy }) => vibrancy.metricGroup)
  const yearFilter = useAppSelector(({ vibrancy }) => vibrancy.configuration.yearFilter)
  const allMetrics = getAllMetricsFromGroups(metricGroups)
  const getMetricName = getMetricByKey(
    allMetrics,
    (currentFilter.metric as any)[currentFilter.metricType]?.[currentFilter.metricValue] || '',
  )
  const getMetricCode = (currentFilter.metric as any)[currentFilter.metricType]?.[currentFilter.metricValue] || ''
  const dataWorldMap = getCountryDataByYearAndMetric(countryData, currentYear, getMetricCode)
  const metricDataTypeMap = useAppSelector(({ vibrancy }) => vibrancy.metricDataTypeMap)

  // Download images
  const fileNameDownload = DOWNLOAD_FILE_NAME.aiMetricOverTimeWorldMap
  const [clickDownload, setClickDownload] = useState<DownloadType>(null)
  const [sliderLimits, setSliderLimits] = useState<{ minYear: number; maxYear: number }>({
    minYear: 2017,
    maxYear: 2024,
  })
  const { setShowDwnLoader } = useActions()
  const { handleCallDownload, divRef } = useImageDownload()
  const handleDivDownload = (type: DownloadType) => {
    setShowDwnLoader(true)
    setClickDownload(type)
  }

  useEffect(() => {
    if (clickDownload) {
      handleCallDownload(clickDownload, {
        fileName: fileNameDownload,
        orientation: 'landscape',
        isSquareDownload: true,
      })
      setClickDownload(null)
    }
  }, [clickDownload])

  const metricDetails = useMemo(() => {
    const allDetailedMetrics: any = []
    metricGroups.forEach((group: any) => {
      if (group?.metrics?.length) {
        allDetailedMetrics.push(...group?.metrics)
      }
    })
    const shortName = (currentFilter.metric as any)[currentFilter.metricType][currentFilter.metricValue]
    const findMetric = allDetailedMetrics.find((m: any) => {
      return m.shortname_raw === shortName && m?.metricValue === currentFilter.metricValue
    })
    return findMetric
  }, [metricGroups, currentFilter])

  const showPercentage = useMemo(() => {
    return metricDataTypeMap[metricDetails?.shortname_raw] === 'Percentage'
  }, [metricDataTypeMap, metricDetails])

  const vendorName = useMemo(() => {
    // const isSourceQuid = metricDetails?.source?.toLowerCase().includes('quid')
    return metricDetails?.source
  }, [metricDetails])

  // const vendorName = 'CSET'
  const yearSource = new Date().getFullYear()
  // const hasData = useMemo(() => {
  //   const values = dataWorldMap.map((obj) => Number(obj.value)).filter((value) => !isNaN(value) && value !== null)
  //   if (values.length > 0 && values.some((i) => i !== 0)) {
  //     return true
  //   } else {
  //     return false
  //   }
  //   // return !!values.length
  // }, [dataWorldMap])

  const convertedData = useMemo(() => {
    if (!showPercentage) return dataWorldMap
    return dataWorldMap.map((ele) => ({
      ...ele,
      value: Number(ele.value) * 100,
    }))
  }, [showPercentage, dataWorldMap])

  useEffect(() => {
    const sl = getYearSliderLimits(countryData, getMetricCode, yearFilter.yearRange)
    setSliderLimits(sl);
  }, [countryData, getMetricCode, yearFilter, currentFilter, metricDetails]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        position: 'relative',
        height: '100%',
        minHeight: '600px',
        // minHeight: hasData ? '600px' : 'auto',
      }}
    >
      {/* {hasData ? (
        <> */}
      <DownloadImages
        handleDownPNG={() => handleDivDownload('png')}
        handleDownJPG={() => handleDivDownload('jpg')}
        handleDownPDF={() => handleDivDownload('pdf')}
      />
      <Box sx={{ padding: '24px', height: '100%' }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            // height: hasData ? undefined : '100%',
          }}
        >
          <ChartHeader
            header1={`${getMetricName}${currentFilter.metricValue === 'perCapita' ? ' Per Capita' : ''
              }, ${currentYear}`}
            header2={`Source: ${vendorName} | Chart: AI Index, ${yearSource}`}
          />
          <SimpleWorldMap
            currentMetricRawName={getMetricCode}
            showPercentage={showPercentage}
            data={convertedData}
            currentYear={currentYear}
            sliderLimits={sliderLimits}
          />
          {/* <WorldmapChart showPercentage={showPercentage} data={convertedData} currentYear={currentYear} /> */}
        </Box>
      </Box>
      <Box sx={{ zIndex: -1, position: 'absolute', padding: '24px', minWidth: '800px' }} ref={divRef}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
          }}
        >
          <ChartHeader
            header1={`${getMetricName}${currentFilter.metricValue === 'perCapita' ? ' Per Capita' : ''
              }, ${currentYear}`}
            header2={`Source: ${vendorName} | Chart: AI Index, ${yearSource}`}
          />
          <SimpleWorldMap
            downloadable={true}
            showPercentage={showPercentage}
            data={convertedData}
            currentMetricRawName={getMetricCode}
            currentYear={currentYear}
          />
          {/* <WorldmapChart showPercentage={showPercentage} data={convertedData} currentYear={currentYear} /> */}
        </Box>
      </Box>
      {/* </>
      ) : (
        <Box sx={{ padding: '24px' }}>
          <Box
            sx={{
              marginBottom: '20px',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
            }}
          >
            <ChartHeader header1={'No data available'} header2='' />
          </Box>
        </Box>
      )} */}
    </Box>
  )
}
